import detail from "./detail";
import list from "./list";
import verify from "./verify";
import verifyAccount from "./verify-account";
import logoutAllDevices from "./logout-all-devices";
import admin from "./admin";
import permission from "./permission";
import statistic from "./statistic";
import bonus from "./bonus";
import customerIo from "./customer-io";

const userModule = {
  namespaced: true,
  modules: {
    list,
    verify,
    detail,
    verifyAccount,
    logoutAllDevices,
    admin,
    permission,
    statistic,
    bonus,
    customerIo,
  },
};

export default userModule;
